export default {
  table: {
    marginLeft: '30px',
    width: '95%',
  },
  link: {
    '&:hover': {
      color: 'blue',
      textDecoration: 'underline',
    },
  },
}
